import React from 'react';

import useUniqueId from '@hooks/useUniqueId';

import CheckCircle from '../CheckCircle';
import {
  BodyText,
  InputStyle,
  RadioButtonStyle,
  SelectBox,
} from './RadioButton.style';

export default function RadioButton({
  children,
  selected = '',
  onClick,
  value = '',
  group = '',
  spacing = '0',
  style,
}: {
  group?: string;
  onClick?: (value: boolean | number | string) => void;
  selected?: boolean | number | string;
  spacing?: string;
  value?: boolean | number | string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  const uniqueID = useUniqueId('radio-button');

  function handleClick() {
    if (onClick) {
      onClick(value);
    }
  }

  return (
    <InputStyle style={style}>
      <label htmlFor={uniqueID} style={{ margin: 0 }}>
        <input
          defaultChecked={selected === value}
          hidden
          id={uniqueID}
          name={group}
          type="radio"
        />
        <SelectBox onClick={handleClick} spacing={spacing}>
          <RadioButtonStyle>
            <CheckCircle selected={selected === value} size={25} />
          </RadioButtonStyle>
          <BodyText style={{ width: '100%' }}>{children}</BodyText>
        </SelectBox>
      </label>
    </InputStyle>
  );
}
